import { createContext, useContext } from "react";

const WebsiteWidthContext = createContext<number | null>(null);

/** Reads the website preview width from the nearest WebsiteWidthContext provider. */
export const useWebsiteWidth = (): number | null =>
  useContext(WebsiteWidthContext);

export default WebsiteWidthContext;
